import { MaybeNil } from '../../utils/interfaces';
import {
  ISlackDestinationFieldsFragment,
  ISlackDestinationInput,
  SlackDestinationType,
} from '../../utils/apollo/graphqlSchema';
import { isNil } from 'lodash';
import { UnreachableCaseError } from 'ts-essentials';
import { ISlackDestinationOption } from './types';

export const toSlackDestinationInput = (
  destination: MaybeNil<ISlackDestinationFieldsFragment>,
): ISlackDestinationInput | null => {
  if (isNil(destination)) {
    return null;
  }

  if (destination.__typename === 'SlackChannelDestination') {
    return {
      type: SlackDestinationType.Channel,
      memberId: null,
      channelId: destination.channel.id,
    };
  } else if (destination.__typename === 'SlackMemberDestination') {
    return {
      type: SlackDestinationType.Member,
      memberId: destination.member.id,
      channelId: null,
    };
  } else {
    throw new UnreachableCaseError(destination);
  }
};

export const getSlackDestinationOption = (
  value: ISlackDestinationFieldsFragment,
): ISlackDestinationOption => {
  if (value.__typename === 'SlackChannelDestination') {
    return value.channel;
  } else if (value.__typename === 'SlackMemberDestination') {
    return value.member;
  } else {
    throw new UnreachableCaseError(value);
  }
};

export const getSlackDestinationOptionOrNull = (
  value: MaybeNil<ISlackDestinationFieldsFragment>,
): ISlackDestinationOption | null => {
  if (isNil(value)) {
    return null;
  }

  return getSlackDestinationOption(value);
};
